import { jsx as a } from "react/jsx-runtime";
import { Th as e } from "@chakra-ui/react";
import { forwardRef as h } from "react";
const i = h(
  ({ children: r, isNumeric: o, colSpan: m, title: t, ...f }, p) => /* @__PURE__ */ a(e, { ref: p, colSpan: m, title: t, isNumeric: o, ...f, children: r })
);
i.displayName = "Th";
export {
  i as Th
};
